import { Menu, Text, UnstyledButton } from '@mantine/core';
import { IconLogout, IconPlayerRecord } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import { useSessionUser } from './use-session-user';
import { UserAvatar } from './user-avatar';

export function UserMenu() {
    const { t } = useTranslation();
    const user = useSessionUser();
    if (!user) return null;
    const subtitle = user.kind === 'guest' ? t('userMenu.guest') : user.email;

    return (
        <Menu position="bottom-end" width="var(--spacing-64)" withinPortal={false}>
            <Menu.Target>
                <UnstyledButton
                    aria-label={t('userMenu.label', { name: user.name })}
                    style={{ borderRadius: 'var(--radius-rounded-full)' }}
                >
                    <UserAvatar name={user.name} size="md" />
                </UnstyledButton>
            </Menu.Target>
            <Menu.Dropdown>
                <Menu.Label>
                    <Text c="bright" fw={500} size="sm" truncate="end">
                        {user.name}
                    </Text>
                    {subtitle && (
                        <Text c="dimmed" size="xs" truncate="end">
                            {subtitle}
                        </Text>
                    )}
                </Menu.Label>
                <Menu.Divider />
                {user.kind === 'employee' && (
                    <Menu.Item
                        component="a"
                        href="/recordings"
                        leftSection={<IconPlayerRecord size={16} />}
                        rel="noopener"
                        target="_blank"
                    >
                        {t('userMenu.recordings')}
                    </Menu.Item>
                )}
                <Menu.Item component="a" href="/api/auth/logout" leftSection={<IconLogout size={16} />}>
                    {t('userMenu.logout')}
                </Menu.Item>
            </Menu.Dropdown>
        </Menu>
    );
}
